/**
 * api/help.js — Хуудасны зааварчилгааны лавлах.
 *
 * ⚠ Бааз нь ЭЗЭН, код (`components/help/helpContent.js`) нь НӨӨЦ.
 *   Тиймээс алдааг ЗАЛГИНА — тусламж татагдахгүй бол хуудас унах ёсгүй,
 *   зүгээр л кодын анхдагч агуулга гарна.
 */
import { API } from "src/api/request";

/** Нэг хуудасны заавар. Олдохгүй бол `{found:false}`. */
export async function fetchHelp(key) {
  const res = await API().get("/xab/help", { params: { key } });
  return res.data;
}

/** Бүх заавар — удирдах хуудсанд. */
export async function fetchHelpList() {
  const res = await API().get("/xab/help");
  return res.data;
}

export async function createHelp(payload) {
  const res = await API().post("/xab/help", payload);
  return res.data;
}

export async function updateHelp(payload) {
  const res = await API().put("/xab/help", payload);
  return res.data;
}

export async function deleteHelp(id) {
  const res = await API().delete("/xab/help", { params: { id } });
  return res.data;
}

/** Зааврын ВИДЕО заавар — MinIO руу (сервер 1080p/CRF20 болгож шахна).
 *  Буцаана: { video_url, video_name, video_seconds, compressed, size }
 *  ⚠ Ижил endpoint — сервер файлын төрлөөр нь ялгаж, өөр хавтсанд хийнэ. */
export async function uploadHelpVideo(file) {
  const form = new FormData();
  form.append("file", file);
  const res = await API().post("/xab/help/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

/** Зааврын дэлгэцийн зураг — MinIO руу. */
export async function uploadHelpImage(file) {
  const form = new FormData();
  form.append("file", file);
  const res = await API().post("/xab/help/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 60000,
  });
  return res.data;
}
